<template>
  <router-view />
</template>

<script>
import { onMounted } from 'vue'
import { useAuthStore } from './stores/auth'

export default {
  name: 'App',
  setup() {
    const authStore = useAuthStore()

    // 应用启动时尝试静默登录（如果有 token）
    onMounted(async () => {
      const hasToken = localStorage.getItem('access_token') ||
                      localStorage.getItem('token') ||
                      localStorage.getItem('refresh_token')

      if (hasToken && !authStore.isAuthenticated) {
        try {
          await authStore.checkAuth()
        } catch (error) {
          console.error('静默登录失败:', error)
        }
      }
    })
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
}
</style>